import { Flex, Stack } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./engagement_placeholder.module.scss";

export const EngagementPlaceholder = () => {
  const { t } = useTranslation(["translation", "bookingModule"]);

  return (
    <Stack className={css.root} gap="spacingSm">
      <Flex className={css.label} alignItems="center">
        <Typography variant="labelRegular">{t("translation:engagement")}</Typography>
      </Flex>
      <Flex alignItems="center" className={css.placeholder}>
        <Typography withMargin variant="bodyBold" tag="span">
          {t("bookingModule:bookings.create.notApplicable")}
        </Typography>
        <TooltipIcon
          content={t("bookingModule:bookings.create.repeatedBookingEngagementInfo")}
          iconProps={{ size: "sm" }}
        />
      </Flex>
    </Stack>
  );
};
